import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import BrIcons from '@components/BrIcons';
/*
Column using MUI Tooltip
*/
export default function TooltipColumnV2({ col, cell }) {
  const className = col.columnConfig.className;

  return (
    <div>
      {cell.value}
      {cell.tooltip && (
        <Tooltip className={className} arrow title={cell.tooltip}>
          <span>
            <BrIcons.Info />
          </span>
        </Tooltip>
      )}
    </div>
  );
}

TooltipColumnV2.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.any,
    tooltip: PropTypes.any,
  }).isRequired,
  col: PropTypes.shape({
    columnConfig: PropTypes.shape({
      className: PropTypes.string,
    }),
  }).isRequired,
};
